import React from "react";
import {
  FormTab,
  BooleanInput,
  Record,
  FormDataConsumer,
  useTranslate,
} from "react-admin";
import { Typography } from "@material-ui/core";
import "./SubscriptionFormFeaturesTab.css";

interface SubscriptionFormFeaturesTabProps {
  record?: Record;
}

const features = ["Feature1", "Feature2"];

export const SubscriptionFormFeaturesTab = (
  props: SubscriptionFormFeaturesTabProps
) => {
  const translate = useTranslate();
  return (
    <FormTab label="resources.master-subscriptions.labels.features" {...props}>
      <FormDataConsumer>
        {(_) => (
          <Typography id="features-title">
            {translate("resources.master-subscriptions.labels.selectFeatures")}
          </Typography>
        )}
      </FormDataConsumer>
      {features.map((f, i) => (
        <BooleanInput
          className="feature-input"
          key={i}
          source={`features[${f}].isSelected`}
          label={f}
        />
      ))}
    </FormTab>
  );
};
